export default __webpack_public_path__ + "static/media/info_box_bg.d1e37af0.png";